/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TextFile
 */
export interface TextFile {
    /**
     * 
     * @type {string}
     * @memberof TextFile
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof TextFile
     */
    encoding?: string;
    /**
     * 
     * @type {string}
     * @memberof TextFile
     */
    name?: string;
}

/**
 * Check if a given object implements the TextFile interface.
 */
export function instanceOfTextFile(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TextFileFromJSON(json: any): TextFile {
    return TextFileFromJSONTyped(json, false);
}

export function TextFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : json['content'],
        'encoding': !exists(json, 'encoding') ? undefined : json['encoding'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function TextFileToJSON(value?: TextFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
        'encoding': value.encoding,
        'name': value.name,
    };
}

